import '.c6{display:inline-flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.i8{padding:0.6rem;}.ssr-plugin'
import '.i9{border-radius:1.875rem;}.ssr-plugin'
import '.ia{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.ib{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.ds{border-radius:2rem;}.ssr-plugin'
import '.ic{overflow-x:hidden;}.ssr-plugin'
import '.c0{overflow-y:auto;}.ssr-plugin'
import '.id{background:var(--page-bg);}.ssr-plugin'
import '.aw{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="c6 b t v i8 i9 ia ib"
      style={{
        ...style,
      }}
    >
      <styled.div className="ds ic c0 id aw"
        style={{
          width,
          height,}}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
